export const csvKeys: any = {
    imperial: [
        {
            title: "Shot Time",
            key: "timestampConverted"
        },
        {
            title: "Target",
            key: "target.targetName"
        },
        {
            title: "Club Name",
            key: "clubName"
        },
        {
            title: "Starred",
            key: "isFavorite"
        },
        {
            title: "Shot Quality",
            key: "shotQuality"
        },
        {
            title: "Target Quality",
            key: "target.targetQuality"
        },
        {
            title: "Combine Score",
            key: "sessionQuality"
        },
        {
            title: "Proximity (Ft.)",
            key: "distanceToPinConverted.valueString"
        },
        {
            title: "Normalized Proximity (Ft.)",
            key: "normalizedDistanceToPinConverted.valueString"
        },
        {
            title: "Apex (Ft.)",
            key: "apexConverted.valueString"
        },
        {
            title: "Normalized Apex (Ft.)",
            key: "normalizedApexConverted.valueString"
        },
        {
            title: "Attack Angle (°)",
            key: "attackAngleConverted.valueString"
        },
        {
            title: "Ball Speed (Mph)",
            key: "ballSpeedConverted.valueString"
        },
        {
            title: "Carry (Yards)",
            key: "carryDistanceConverted.valueString"
        },
        {
            title: "Normalized Carry (Yards)",
            key: "normalizedCarryDistanceConverted.valueString"
        },
        {
            title: "Club Path (°)",
            key: "clubPathConverted.valueString"
        },
        {
            title: "Face to Path (°)",
            key: "faceToPathConverted.valueString"
        },
        {
            title: "Club Speed (Mph)",
            key: "clubSpeedConverted.valueString"
        },
        {
            title: "Face Angle (°)",
            key: "faceAngleConverted.valueString"
        },
        {
            title: "Horizontal Launch Angle (°)",
            key: "horizontalLaunchAngleConverted.valueString"
        },
        {
            title: "Launch Angle (°)",
            key: "launchAngleConverted.valueString"
        },
        {
            title: "Side Total (Yards)",
            key: "sideTotalConverted.sideValueString"
        },
        {
            title: "Normalized Side Total (Yards)",
            key: "normalizedSideTotalConverted.sideValueString"
        },
        {
            title: "Side Carry (Yards)",
            key: "sideConverted.sideValueString"
        },
        {
            title: "Normalized Side Carry (Yards)",
            key: "normalizedSideConverted.sideValueString"
        },
        {
            title: "Smash Factor",
            key: "smashFactorConverted.valueString"
        },
        {
            title: "Spin Axis (°)",
            key: "spinAxisConverted.valueString"
        },
        {
            title: "Spin Rate (Rpms)",
            key: "spinRateConverted.valueString"
        },
        {
            title: "Total (Yards)",
            key: "totalDistanceConverted.valueString"
        },
        {
            title: "Normalized Total (Yards)",
            key: "normalizedTotalDistanceConverted.valueString"
        }
    ],
    metric: [
        {
            title: "Target",
            key: "target.targetName"
        },
        {
            title: "Club Name",
            key: "clubName"
        },
        {
            title: "Starred",
            key: "isFavorite"
        },
        {
            title: "Shot Quality",
            key: "shotQuality"
        },
        {
            title: "Target Quality",
            key: "target.targetQuality"
        },
        {
            title: "Combine Score",
            key: "sessionQuality"
        },
        {
            title: "Proximity (Meters.)",
            key: "distanceToPinConverted.valueString"
        },
        {
            title: "Normalized Proximity (Meters.)",
            key: "normalizedDistanceToPinConverted.valueString"
        },
        {
            title: "Apex (Meters)",
            key: "apexConverted.valueString"
        },
        {
            title: "Normalized Apex (Meters)",
            key: "normalizedApexConverted.valueString"
        },
        {
            title: "Attack Angle (°)",
            key: "attackAngleConverted.valueString"
        },
        {
            title: "Ball Speed (Kph)",
            key: "ballSpeedConverted.valueString"
        },
        {
            title: "Carry (Meters)",
            key: "carryDistanceConverted.valueString"
        },
        {
            title: "Normalized Carry (Meters)",
            key: "normalizedCarryDistanceConverted.valueString"
        },
        {
            title: "Club Path (°)",
            key: "clubPathConverted.valueString"
        },
        {
            title: "Face to Path (°)",
            key: "faceToPathConverted.valueString"
        },
        {
            title: "Club Speed (Kph)",
            key: "clubSpeedConverted.valueString"
        },
        {
            title: "Face Angle (°)",
            key: "faceAngleConverted.valueString"
        },
        {
            title: "Hor Launch Angle (°)",
            key: "horizontalLaunchAngleConverted.valueString"
        },
        {
            title: "Launch Angle (°)",
            key: "launchAngleConverted.valueString"
        },
        {
            title: "Side Total (Meters)",
            key: "sideTotalConverted.sideValueString"
        },
        {
            title: "Normalized Side Total (Meters)",
            key: "normalizedSideTotalConverted.sideValueString"
        },
        {
            title: "Side Carry (Meters)",
            key: "sideConverted.sideValueString"
        },
        {
            title: "Normalized Side Carry (Meters)",
            key: "normalizedSideConverted.sideValueString"
        },
        {
            title: "Smash Factor",
            key: "smashFactorConverted.valueString"
        },
        {
            title: "Spin Axis (°)",
            key: "spinAxisConverted.valueString"
        },
        {
            title: "Spin Rate (Rpms)",
            key: "spinRateConverted.valueString"
        },
        {
            title: "Total (Meters)",
            key: "totalDistanceConverted.valueString"
        },
        {
            title: "Normalized Total (Meters)",
            key: "normalizedTotalDistanceConverted.valueString"
        }
    ]
}

export const csvKeysClub: any = {
    imperial: [
        {
            title: "Shot Time",
            key: "timestampConverted"
        },
        {
            title: "Club Name",
            key: "clubName"
        },
        {
            title: "Starred",
            key: "isFavorite"
        },
        {
            title: "Apex (Ft.)",
            key: "apexConverted.valueString"
        },
        {
            title: "Normalized Apex (Ft.)",
            key: "normalizedApexConverted.valueString"
        },
        {
            title: "Attack Angle (°)",
            key: "attackAngleConverted.valueString"
        },
        {
            title: "Ball Speed (Mph)",
            key: "ballSpeedConverted.valueString"
        },
        {
            title: "Carry (Yards)",
            key: "carryDistanceConverted.valueString"
        },
        {
            title: "Normalized Carry (Yards)",
            key: "normalizedCarryDistanceConverted.valueString"
        },
        {
            title: "Club Path (°)",
            key: "clubPathConverted.valueString"
        },
        {
            title: "Face to Path (°)",
            key: "faceToPathConverted.valueString"
        },
        {
            title: "Club Speed (Mph)",
            key: "clubSpeedConverted.valueString"
        },
        {
            title: "Face Angle (°)",
            key: "faceAngleConverted.valueString"
        },
        {
            title: "Horizontal Launch Angle (°)",
            key: "horizontalLaunchAngleConverted.valueString"
        },
        {
            title: "Launch Angle (°)",
            key: "launchAngleConverted.valueString"
        },
        {
            title: "Side Total (Yards)",
            key: "sideTotalConverted.sideValueString"
        },
        {
            title: "Normalized Side Total (Yards)",
            key: "normalizedSideTotalConverted.sideValueString"
        },
        {
            title: "Side Carry (Yards)",
            key: "sideConverted.sideValueString"
        },
        {
            title: "Normalized Side Carry (Yards)",
            key: "normalizedSideConverted.sideValueString"
        },
        {
            title: "Smash Factor",
            key: "smashFactorConverted.valueString"
        },
        {
            title: "Spin Axis (°)",
            key: "spinAxisConverted.valueString"
        },
        {
            title: "Spin Rate (Rpms)",
            key: "spinRateConverted.valueString"
        },
        {
            title: "Total (Yards)",
            key: "totalDistanceConverted.valueString"
        },
        {
            title: "Normalized Total (Yards)",
            key: "normalizedTotalDistanceConverted.valueString"
        }
    ],
    metric: [
        {
            title: "Shot Time",
            key: "timestampConverted"
        },
        {
            title: "Club Name",
            key: "clubType"
        },
        {
            title: "Starred",
            key: "isFavorite"
        },
        {
            title: "Apex (Meters)",
            key: "apexConverted.valueString"
        },
        {
            title: "Normalized Apex (Meters)",
            key: "normalizedApexConverted.valueString"
        },
        {
            title: "Attack Angle (°)",
            key: "attackAngleConverted.valueString"
        },
        {
            title: "Ball Speed (Kph)",
            key: "ballSpeedConverted.valueString"
        },
        {
            title: "Carry (Meters)",
            key: "carryDistanceConverted.valueString"
        },
        {
            title: "Normalized Carry (Meters)",
            key: "normalizedCarryDistanceConverted.valueString"
        },
        {
            title: "Club Path (°)",
            key: "clubPathConverted.valueString"
        },
        {
            title: "Face to Path (°)",
            key: "faceToPathConverted.valueString"
        },
        {
            title: "Club Speed (Kph)",
            key: "clubSpeedConverted.valueString"
        },
        {
            title: "Face Angle (°)",
            key: "faceAngleConverted.valueString"
        },
        {
            title: "Hor Launch Angle (°)",
            key: "horizontalLaunchAngleConverted.valueString"
        },
        {
            title: "Launch Angle (°)",
            key: "launchAngleConverted.valueString"
        },
        {
            title: "Side Total (Meters)",
            key: "sideTotalConverted.sideValueString"
        },
        {
            title: "Normalized Side Total (Meters)",
            key: "normalizedSideTotalConverted.sideValueString"
        },
        {
            title: "Side Carry (Meters)",
            key: "sideConverted.sideValueString"
        },
        {
            title: "Normalized Side Carry (Meters)",
            key: "normalizedSideConverted.sideValueString"
        },
        {
            title: "Smash Factor",
            key: "smashFactorConverted.valueString"
        },
        {
            title: "Spin Axis (°)",
            key: "spinAxisConverted.valueString"
        },
        {
            title: "Spin Rate (Rpms)",
            key: "spinRateConverted.valueString"
        },
        {
            title: "Total (Meters)",
            key: "totalDistanceConverted.valueString"
        },
        {
            title: "Normalized Total (Meters)",
            key: "normalizedTotalDistanceConverted.valueString"
        }
    ]
}